/*
 * @Description:
 * @Author: hanyu
 * @Date: 2020-03-12 17:13:42
 * @LastEditTime: 2021-03-02 15:19:01
 * @LastEditors: hanyu
 */
import common from './common';
import pagination from './pagination.js';
import course from './course';
import account from './account';
import pay from './pay';
import empty from './empty';
import book from './book';
import order from './order';
import distribution from './distribution';
import seo from './seo';

export default {
  ...common,
  ...pagination,
  ...course,
  ...account,
  ...pay,
  ...empty,
  ...book,
  ...order,
  ...distribution,
  ...seo
};
